<mat-expansion-panel #datosEmpresa [disabled]="flujo.bloqueado" [formGroup]="datosDeEmpresa" hideToggle [expanded]="
    !flujo.ok &&
    !flujo.cargando">
  <mat-expansion-panel-header>
    <mat-panel-title> Datos de la empresa </mat-panel-title>
    <mat-panel-description>
      <div *ngIf="
          !flujo.ok &&
          !flujo.cargando &&
          showCantidadCampos">
        <!--======informacion menu ======-->
        Completa sólo {{ calculaCantidadALlenar }} datos
      </div>
      <div *ngIf="flujo.cargando">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="flujo.ok && !flujo.cargando">
        <!--======ok menu ======-->
        <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <app-messages *ngIf="showInfoMessage" class="informativoSS mt-16 mb-16 p-16"
    message='<strong>Importante:</strong> La información utilizada en nuestra plataforma proviene de fuentes públicas y autorizadas (Servicio de Impuestos Internos).'></app-messages>
  <ng-container *ngIf="!flujo.cargando && flujo.mostrar">
    <!--
    <div class="row" *ngIf="!esComercioFormal && identificacionComercio.actividadEconomica === null">
      <div class="col-md-12">
        <p class="p-inicioActividad mt-16">
          ¿Tienes inicio de actividades en el SII?
        </p>
        <mat-radio-group [disabled]="precarga || !edicion || bloquearRadios" (change)="changeInicio()" formControlName="inicioActividades">
          <mat-radio-button tabindex="1" name="iniciaActividad" value="iniciaActividad" class="mr-63">Si</mat-radio-button>
          <mat-radio-button name="noIniciaActividad" value="noIniciaActividad">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  -->
    <ng-container *ngIf="esUnoaUno; else comercioNormal">
      <div class="row">
        <!-- Campos Actividades Economicas Inscritas SII -->
        <div class="col-md-6 mt-36">
          <label for="actividadesEconomicas">Actividades económicas inscritas en SII</label>
          <select name="actividadesEconomicas" formControlName="actividadesEconomicas" disabled>
            <option [ngValue]="identificacionComercio.actividadesEconomicasDisponibles[0].id">
                {{identificacionComercio.actividadesEconomicasDisponibles[0].asString}}
            </option>
          </select>
        </div>
        <!-- Campos Categoría que refleja tu empresa -->
        <div class="col-md-6 mt-36">
          <label for="categoriaComercio">Categoría que refleja tu negocio</label>
          <select name="categoriaComercio" formControlName="categoriaComercio" disabled>
            <option [ngValue]="identificacionComercio.actividadesEconomicasDisponibles[0].relacion[0].id">
              {{ identificacionComercio.actividadesEconomicasDisponibles[0].relacion[0].asString }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>

    <ng-template #comercioNormal>
      <div class="row" *ngIf="identificacionComercio">
        <!-- Actividades -->
        <div class="col-md-6 mt-36" *ngIf="actEconomic && !existePersonaNaturalPrecarga">
          <label for="actividadesEconomicas">Actividades económicas inscritas en SII</label>
          
          <select name="actividadesEconomicas" formControlName="actividadesEconomicas" [class.selectInvalido]="datosDeEmpresa.get('actividadesEconomicas').invalid && (datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched)" 
            *ngIf="((identificacionComercio.actividadEconomica !== null || bloqActandRubro) && identificacionComercio.actividadEconomica.id !== -1) && !submitted" disabled>
            <option [ngValue]="identificacionComercio.actividadEconomica?.id || ''">
              {{ identificacionComercio.actividadEconomica?.asString || "" }}
            </option>
          </select>

          <select name="actividadesEconomicas" formControlName="actividadesEconomicas" [class.selectInvalido]="datosDeEmpresa.get('actividadesEconomicas').invalid && (datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched)" 
            *ngIf="((identificacionComercio.actividadEconomica !== null || bloqActandRubro) && identificacionComercio.actividadEconomica.id === -1) && !submitted" disabled>
            <option [ngValue]="identificacionComercio.actividadEconomica?.id || ''">
              {{ identificacionComercio.actividadEconomica?.asString || "" }}
            </option>
          </select>

          <!-- desde acá el select search -->
          <mat-select class="select mat-select" placeholder="Ingresar actividades económicas" name="actividadesEconomicas" 
            formControlName="actividadesEconomicas"
            panelClass="agranda-panel" 
            [class.selectInvalido]="datosDeEmpresa.get('actividadesEconomicas').invalid && (datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched)" 
            (selectionChange)="cambioActividad()" 
            (click)="inicializaActividadesEconomicas()" 
            *ngIf="(!precarga && identificacionComercio.actividadesEconomicasDisponibles.length > 1 && edicion) && !submitted">
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Filtrar actividades económicas" [noEntriesFoundLabel]="'No hay coincidencias'" [formControl]="filterCtrl"
                (keyup)="filtrarActividadesEconomicasDisponibles($event)">
                <mat-icon ngxMatSelectSearchClear (click)="inicializaActividadesEconomicas()">
                  <i class="icon-eliminar c-mover-derecha tex-al-right" style="margin-top: 0px;"></i>
                </mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let actividad of filtroActividadesEconomicasDisponibles; let indice = index" [value]="actividad.id" style="font-size: 14px; margin-bottom: 6px;">
              {{ actividad.asString }}
            </mat-option>
          </mat-select>
          <!-- hasta acá el select search -->

          <select name="actividadesEconomicas" formControlName="actividadesEconomicas" 
            [class.selectInvalido]="datosDeEmpresa.get('actividadesEconomicas').invalid && (datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched)" 
            *ngIf="(!precarga && identificacionComercio.actividadesEconomicasDisponibles.length > 1 && !edicion) || submitted" 
            (change)="cambioActividad()" disabled>
            <option value="" selected>Ingresar actividades económicas</option>
            <option *ngFor="let actividad of identificacionComercio.actividadesEconomicasDisponibles; let indice = index" [ngValue]="actividad.id">
              {{ actividad.asString }}
            </option>
          </select>

          <select name="actividadesEconomicas" formControlName="actividadesEconomicas" 
            [class.selectInvalido]="datosDeEmpresa.get('actividadesEconomicas').invalid && (datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched)" 
            *ngIf="!precarga && identificacionComercio.actividadesEconomicasDisponibles.length === 1" 
            (change)="cambioActividad()" disabled>
            <option value="" selected>Ingresar actividades económicas</option>
            <option *ngFor="let actividad of identificacionComercio.actividadesEconomicasDisponibles; let indice = index" 
              [ngValue]="actividad.id">
              {{ actividad.asString }}
            </option>
          </select>

          <p *ngIf="((datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched) && datosDeEmpresa.get('actividadesEconomicas') === null) 
            || ((datosDeEmpresa.get('actividadesEconomicas').dirty || datosDeEmpresa.get('actividadesEconomicas').touched) && datosDeEmpresa.get('actividadesEconomicas').invalid) " 
            class="mensajeError">
            {{ mensajeErrorDatosEmpresa.REQUIRED_ECONOMICACTIVITY_MESSAGE }}
          </p>
        </div>
        <!-- fin Actividades -->

        <!-- Categoria -->
        <div class="col-md-6 mt-36">
          <label for="categoriaComercio">Categoría que refleja tu negocio</label>

          <select name="categoriaComercio" (change)="selRubro()" formControlName="categoriaComercio" 
            [class.selectInvalido]="datosDeEmpresa.get('categoriaComercio').invalid && (datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched)" 
            *ngIf="(identificacionComercio.actividadEconomica !== null) && !submitted" disabled>
            <option *ngIf="precarga" [ngValue]="identificacionComercio.actividadEconomica?.relacion[0]?.id || ''" selected>
              {{ identificacionComercio.actividadEconomica?.relacion[0]?.asString || "" }}
            </option>
          </select>

          <select name="categoriaComercio" (change)="selRubro()" formControlName="categoriaComercio" 
            [class.selectInvalido]="datosDeEmpresa.get('categoriaComercio').invalid && (datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched)" 
            *ngIf="(!precarga && (rubros ? rubros : []).length === 1) && !submitted" disabled>
            <option value="" selected>Ingresar categoría</option>
            <option *ngFor="let rubro of rubros" [ngValue]="rubro.id" selected>
              {{ rubro.asString }}
            </option>
          </select>

          <!-- inicio select search en categoria rubro -->
          <select name="categoriaComercio" (change)="selRubro()" formControlName="categoriaComercio" 
            [class.selectInvalido]="datosDeEmpresa.get('categoriaComercio').invalid && (datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched)" 
            *ngIf=" actEconomic && (!precarga && ((rubros ? rubros : []).length > 1 || (rubros ? rubros : []).length === 0) && edicion) && !submitted">
            <option value="" selected>Ingresar categoría</option>
            <option *ngFor="let rubro of rubros" [ngValue]="rubro.id" selected>
              {{ rubro.asString }}
            </option>
          </select>

          <mat-select class="select mat-select" name="categoriaComercio" placeholder="Ingresar categoría" formControlName="categoriaComercio" panelClass="agranda-panel-categoria"
            [class.selectInvalido]="datosDeEmpresa.get('categoriaComercio').invalid && (datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched)" 
            (selectionChange)="selRubro()" 
            (click)="inicializaCategorias()" 
            *ngIf=" !actEconomic && (!precarga && ((rubros ? rubros : []).length > 1 || (rubros ? rubros : []).length === 0) && edicion) && !submitted">
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Filtrar categorías" [noEntriesFoundLabel]="'No hay coincidencias'" [formControl]="filterCtrlCategoria"
                (keyup)="filtrarCategorias($event)">
                <mat-icon ngxMatSelectSearchClear (click)="inicializaCategorias()">
                  <i class="icon-eliminar c-mover-derecha tex-al-right" style="margin-top: 0px;"></i>
                </mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let rubro of filtroRubros" [value]="rubro.id" style="font-size: 14px; margin-bottom: 6px;">
              {{ rubro.asString }}
            </mat-option>
          </mat-select>
          <!-- fin select search en categoria rubro -->

          <select name="categoriaComercio" (change)="selRubro()" formControlName="categoriaComercio" 
            [class.selectInvalido]="datosDeEmpresa.get('categoriaComercio').invalid && (datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched)" 
            *ngIf=" (!precarga && ((rubros ? rubros : []).length > 1 || (rubros ? rubros : []).length === 0) && !edicion) || submitted" disabled>
            <option value="" selected>Ingresar categoría</option>
            <option *ngFor="let rubro of rubros" [ngValue]="rubro.id" selected>
              {{ rubro.asString }}
            </option>
          </select>

          <p *ngIf="((datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched) && datosDeEmpresa.get('categoriaComercio') === null) || ((datosDeEmpresa.get('categoriaComercio').dirty || datosDeEmpresa.get('categoriaComercio').touched) && datosDeEmpresa.get('categoriaComercio').invalid)" class="mensajeError">
            {{ mensajeErrorDatosEmpresa.REQUIRED_CATEGORY_MESSAGE }}
          </p>
        </div>
        <!-- fin Categoria -->
      </div>
    </ng-template>

    <div class="row">
      <!-- Campo Razon Social -->
      <div class="col-md-6 mt-36">
        <label for="razonSocial">Razón Social</label>

        <div class="label-right" [popper]=mensajeErrorDatosEmpresa.RAZON_SOCIAL_TOOLTIP [popperPlacement]="'bottom-end'"
          [popperTrigger]="'hover'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true"
          [popperApplyClass]="'popperstyle-blue'">¿Dónde lo encuentro? &nbsp;<i class="informativo-blue"></i></div>
      
        <ng-container *ngIf="razonSocialDisable; else inputHabilitado">
          <input [readOnly]="!edicion" type="text" name="razonSocial" formControlName="razonSocial"
          placeholder="Ingresa razón social" autocomplete="off" appMaxLength="40"
          [ngClass]="{inputInvalido: datosDeEmpresa.get('razonSocial').invalid && (datosDeEmpresa.get('razonSocial').dirty || datosDeEmpresa.get('razonSocial').touched)}"
          disabled />
        </ng-container>
        <ng-template #inputHabilitado>
          <input [readOnly]="!edicion" type="text" name="razonSocial" formControlName="razonSocial"
          placeholder="Ingresa razón social" autocomplete="off" appMaxLength="40"
          [ngClass]="{inputInvalido: datosDeEmpresa.get('razonSocial').invalid && (datosDeEmpresa.get('razonSocial').dirty || datosDeEmpresa.get('razonSocial').touched)}"
          required />
        </ng-template>
      
        <p class="mensajeError"
          *ngIf="
                  ((datosDeEmpresa.get('razonSocial').dirty || datosDeEmpresa.get('razonSocial').touched) && datosDeEmpresa.get('razonSocial') === null) ||
                  ((datosDeEmpresa.get('razonSocial').dirty || datosDeEmpresa.get('razonSocial').touched) && datosDeEmpresa.get('razonSocial').invalid)">
          {{ mensajeErrorDatosEmpresa.REQUIRED_RAZONSOCIAL_MESSAGE }}
        </p>
      </div>
      <!-- fin Campo Razon Social -->

      <!-- Campo Nombre de Fantasia-->
      <div class="col-md-6 mt-36">
        <label for="nombreFantasia">Nombre de fantasía</label>
        <div class="label-right" [popper]=mensajeErrorDatosEmpresa.NOMBRE_FANTASIA_TOOLTIP [popperPlacement]="'bottom-end'" [popperTrigger]="'hover'" [popperHideOnClickOutside]="true"
            [popperHideOnScroll]="true" [popperApplyClass]="'popperstyle-blue'">¿Para qué sirve? &nbsp;<i class="informativo-blue"></i></div>
        <input [readOnly]="!edicion" type="text" name="nombreFantasia" formControlName="nombreFantasia" placeholder="Ingresa nombre fantasía" autocomplete="off" appMaxLength="25"
          [ngClass]="{inputInvalido: datosDeEmpresa.get('nombreFantasia').invalid && (datosDeEmpresa.get('nombreFantasia').dirty || datosDeEmpresa.get('nombreFantasia').touched)}" required />
        <p class="mensajeError" *ngIf="((datosDeEmpresa.get('nombreFantasia').dirty || datosDeEmpresa.get('nombreFantasia').touched) && datosDeEmpresa.get('nombreFantasia') === null) || ((datosDeEmpresa.get('nombreFantasia').dirty || datosDeEmpresa.get('nombreFantasia').touched) && datosDeEmpresa.get('nombreFantasia').invalid)">
          {{ mensajeErrorDatosEmpresa.REQUIRED_FANTASYNAME_MESSAGE }}
        </p>
      </div>
    </div>
    <div class="row" *ngIf="((datosDeEmpresa.get('nombreFantasia').dirty || datosDeEmpresa.get('nombreFantasia').touched) && datosDeEmpresa.get('nombreFantasia') === null) || ((datosDeEmpresa.get('nombreFantasia').dirty || datosDeEmpresa.get('nombreFantasia').touched) && datosDeEmpresa.get('nombreFantasia').invalid)">
      <div class="col-md-12">
        <app-messages class="advertencia mt-36" [message]=" 'Recuerda que este nombre aparecerá en la parte superior de tu voucher' "></app-messages>
      </div>
    </div>

    <!-- Campos Descripción Negocio-->
    <div class="row" *ngIf="showDescripcionNegocio">
      <div class="col-md-12 mt-36">
        <div class="ng-container mb-16" *ngIf="rubroSeleccionadoMCC">
          <label class="descrip-mcc">¿Esta descripción se ajusta a lo que vendes?</label>
          <br>
          <mat-radio-group (change)="onDescripcionChange($event)" aria-label="Seleccionar opción">
            <mat-radio-button [value]="true" [checked]="true" class="radio-inline mr-63">Sí</mat-radio-button><br>
            <mat-radio-button [value]="false" class="radio-inline">No, quiero ingresar otra descripción</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="ng-container" *ngIf="!rubroSeleccionadoMCC">
          <label for="descripcion">Descripción de tu negocio</label>
        </div>
        <textarea [readOnly]="!edicion" name="descripcion" (keyup)="onKey($event)" formControlName="descripcion"
          placeholder="Agrega una descripción sobre los productos o servicios que vendes en tu comercio. " row="40" (keydown)="maxLengthTextArea(1000)" autocomplete="off" [ngClass]="{
            selectInvalido:
              (datosDeEmpresa.get('descripcion').dirty ||
                datosDeEmpresa.get('descripcion').touched) &&
              (datosDeEmpresa.get('descripcion').value === '' ||
                !datosDeEmpresa.get('descripcion').value), disable: (rubroSeleccionadoMCC && !edicionText)
          }"></textarea>
        <span class="caracteres-textarea">{{ contador }} caracteres máximo</span>
        <p class="mensajeError" *ngIf="
            (datosDeEmpresa.get('descripcion').dirty ||
              datosDeEmpresa.get('descripcion').touched) &&
            (datosDeEmpresa.get('descripcion').value === '' ||
              !datosDeEmpresa.get('descripcion').value)
          ">
          {{ mensajeErrorDatosEmpresa.REQUIRED_DESCRIPTION_MESSAGE }}
        </p>
        <div *ngIf="rubroSeleccionadoMCC" class="alert alert-primary alert-tbk" role="alert">
          <div class="row">
            <div class="col-1">
              <i class="icon-info-fullfilled"></i>
            </div>
            <div class="col">
              La descripción de tu comercio es necesaria, para evaluar el riesgo que significa tu relación con Transbank,
              esto dependerá de lo que vende tu negocio y está relacionado a un
              <a href="#" class="alert-link" (click)="abrirCobroAdicionalmodal(); $event.preventDefault()">
                cobro adicional
              </a>.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Direccion por google -->
    <app-autocompletar (setDireccion)="edicion ? obtenerDireccion($event) : null"></app-autocompletar>

    <div class="row">
      <!-- Campos Region -->
      <div class="col-md-6 mt-36">
        <label for="region">Region</label>
        <select name="region" formControlName="region" [ngClass]="{
            selectInvalido:
              datosDeEmpresa.get('region').invalid &&
              (datosDeEmpresa.get('region').dirty ||
                datosDeEmpresa.get('region').touched)
          }" (change)="setRegion()" required *ngIf="edicion">
          <option value="">Seleccionar</option>
          <option *ngFor="let region of localizaciones; let indice = index" [ngValue]="indice">
            {{ region.asString }}
          </option>
        </select>
        <select name="region" formControlName="region" [ngClass]="{
            selectInvalido:
              datosDeEmpresa.get('region').invalid &&
              (datosDeEmpresa.get('region').dirty ||
                datosDeEmpresa.get('region').touched)
          }" (change)="setRegion()" required *ngIf="!edicion" disabled>
          <option value="">Seleccionar</option>
          <option *ngFor="let region of localizaciones; let indice = index" [ngValue]="indice">
            {{ region.asString }}
          </option>
        </select>
        <p *ngIf="
            ((datosDeEmpresa.get('region').dirty ||
              datosDeEmpresa.get('region').touched) &&
              datosDeEmpresa.get('region') === null) ||
            ((datosDeEmpresa.get('region').dirty ||
              datosDeEmpresa.get('region').touched) &&
              datosDeEmpresa.get('region').invalid)
          " class="mensajeError">
          {{ mensajeErrorDatosEmpresa.REQUIRED_ESTATE_MESSAGE }}
        </p>
      </div>
      <!-- Campo de Comuna -->
      <div class="col-md-6 mt-36">
        <label for="comuna">Comuna</label>
        <select name="comuna" formControlName="comuna" [ngClass]="{
            selectInvalido:
              datosDeEmpresa.get('comuna').invalid &&
              (datosDeEmpresa.get('comuna').dirty ||
                datosDeEmpresa.get('comuna').touched)
          }" required *ngIf="edicion">
          <option value="">Seleccionar</option>
          <option *ngFor="let comuna of regionSelected?.comunas || []" [ngValue]="comuna.id">
            {{ comuna.asString }}
          </option>
        </select>
        <select name="comuna" formControlName="comuna" [ngClass]="{
            selectInvalido:
              datosDeEmpresa.get('comuna').invalid &&
              (datosDeEmpresa.get('comuna').dirty ||
                datosDeEmpresa.get('comuna').touched)
          }" required *ngIf="!edicion" disabled>
          <option value="">Seleccionar</option>
          <option *ngFor="let comuna of regionSelected?.comunas || []" [ngValue]="comuna.id">
            {{ comuna.asString }}
          </option>
        </select>
        <p *ngIf="
            ((datosDeEmpresa.get('comuna').dirty ||
              datosDeEmpresa.get('comuna').touched) &&
              datosDeEmpresa.get('comuna') === null) ||
            ((datosDeEmpresa.get('comuna').dirty ||
              datosDeEmpresa.get('comuna').touched) &&
              datosDeEmpresa.get('comuna').invalid)
          " class="mensajeError">
          {{ mensajeErrorDatosEmpresa.REQUIRED_CITY_MESSAGE }}
        </p>
      </div>
    </div>
    <div class="row">
      <!-- Campo de Direccion -->
      <div class="col-md-6 mt-36">
        <label for="avenidaCallePasaje">Avenida/Calle/Pasaje</label>
        <input [readOnly]="!edicion" appCaracteresNumeros type="text" name="avenidaCallePasaje" formControlName="avenidaCallePasaje" placeholder="Ingresar Avenida / Calle / Pasaje"
          autocomplete="off" appMaxLength="40" [ngClass]="{
            inputInvalido:
              datosDeEmpresa.get('avenidaCallePasaje').invalid &&
              (datosDeEmpresa.get('avenidaCallePasaje').dirty ||
                datosDeEmpresa.get('avenidaCallePasaje').touched)
          }" required />
        <p *ngIf="
            ((datosDeEmpresa.get('avenidaCallePasaje').dirty ||
              datosDeEmpresa.get('avenidaCallePasaje').touched) &&
              datosDeEmpresa.get('avenidaCallePasaje') === null) ||
            ((datosDeEmpresa.get('avenidaCallePasaje').dirty ||
              datosDeEmpresa.get('avenidaCallePasaje').touched) &&
              datosDeEmpresa.get('avenidaCallePasaje').invalid)
          " class="mensajeError">
          {{ mensajeErrorDatosEmpresa.REQUIRED_ADDRESS_MESSAGE }}
        </p>
      </div>
      <!-- Campo de Numero de Calle -->
      <div class="col-md-6 mt-36">
        <label for="numeroCalle">Número calle</label>
        <input [readOnly]="!edicion" appNumeros type="text" inputmode="numeric" name="numeroCalle" formControlName="numeroCalle" placeholder="Ingresar número calle "
          autocomplete="off" appMaxLength="6" [ngClass]="{
            inputInvalido:
              datosDeEmpresa.get('numeroCalle').invalid &&
              (datosDeEmpresa.get('numeroCalle').dirty ||
                datosDeEmpresa.get('numeroCalle').touched)
          }" required />
        <p *ngIf="
            ((datosDeEmpresa.get('numeroCalle').dirty ||
              datosDeEmpresa.get('numeroCalle').touched) &&
              datosDeEmpresa.get('numeroCalle') === null) ||
            ((datosDeEmpresa.get('numeroCalle').dirty ||
              datosDeEmpresa.get('numeroCalle').touched) &&
              datosDeEmpresa.get('numeroCalle').invalid)
          " class="mensajeError">
          {{ mensajeErrorDatosEmpresa.REQUIRED_STREETNUMBER_MESSAGE }}
        </p>
      </div>
    </div>
    <div class="row">
      <!-- Campo de Numero Local Apt -->
      <div class="col-md-6 mt-36">
        <label for="numeroLocal">Número de local o departamento (opcional)</label>
        <input [readOnly]="!edicion" type="text" name="numeroLocal" formControlName="numeroLocal" placeholder="Ingresar número de local" appMaxLength="10" autocomplete="off"
          [class.inputInvalido]="
            datosDeEmpresa.get('numeroLocal').invalid &&
            (datosDeEmpresa.get('numeroLocal').dirty ||
              datosDeEmpresa.get('numeroLocal').touched)
          " />
      </div>
    </div>
    <div class="row box-button">
      <div class="col-md-12">
        <button class="btn-primary-tbk" type="submit" value="Continuar" [disabled]="formInvalid()" (click)="Continuar($event)">
          <div *ngIf="loading" class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div *ngIf="!loading">Guardar</div>
        </button>
      </div>
    </div>
  </ng-container>
</mat-expansion-panel>
